import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Form from './Forms'
import { TextField, Button, MenuItem, Select, FormControl, InputLabel, Checkbox } from "@mui/material";
import Swal from 'sweetalert2'
import './style.css'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { Country, City } from 'country-state-city';
import Logo from "./logo-removebg-preview.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Register = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [c_password, setc_Password] = useState('');
    const [validate, setValidate] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [c_showPassword, setc_ShowPassword] = useState(false);
    const [age, setAge] = useState('');

    const [value, setValue] = useState();
    const [country, setCountry] = useState('');
    const [city, setCity] = useState('');
    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);
    
    useEffect(() => {
        setCountries(Country.getAllCountries());
    }, []);

    useEffect(() => {
        if (country) setCities(City.getCitiesOfCountry(country.isoCode));
    }, [country]);

    const handleChange = (event) => {
      setAge(event.target.value);
    };

    const validateRegister = () => {
        let isValid = true;

        let validator = Form.validator({
            name: {
                value: name,
                isRequired: true,
            },
            email: {
                value: email,
                isRequired: true,
                isEmail: true
            },
            password: {
                value: password,
                isRequired: true,
                minLength: 8
            }
        });

        if (validator !== null) {
            setValidate({
                validate: validator.errors
            })

            isValid = false
        }
        return isValid;
    }

    const register = (e) => {
        e.preventDefault();

        const validate = validateRegister();

        if (validate) {
            setValidate({});
            setName('');
            setEmail('');
            setPassword('');
            Swal.fire({
                icon: 'success',
                // title:'Thank you for your request.',
                // text: 'Our team will be in contact with you.',
                title:'Successfully Register',
                text: 'Check your email to activate your account.',
                showConfirmButton: true,
    
            })
        }
    }

    const togglePassword = (e) => {
        if (showPassword) {
            setShowPassword(false);
        } else {
            setShowPassword(true)
        }
    }
    const togglePassword2 = (e) => {
        if (c_showPassword) {
            setc_ShowPassword(false);
        } else {
            setc_ShowPassword(true)
        }
    }

    return (
        <div className="row g-0 auth-wrapper">
            <div className="col-12 col-md-5 col-lg-6 h-100 auth-background-col">
                <div className="auth-background-holder"></div>
                <div className="auth-background-mask">
 
                <div 
                    data-aos="fade-right"
                    data-aos-duration="1000"
                    data-aos-easing="ease-in-out"
                    >
                    <h1>Welcome to </h1>
                    <h3>Rent by broker</h3>
                    </div>

                </div>
            </div>

            <div className="col-12 col-md-7 col-lg-6 auth-main-col text-center">
              
                <div className="d-flex flex-column align-content-end  rigister-form-scroll">
                    <div className="auth-body mx-auto">
                    <Link to="/" style={{textDecoration:"none"}}>
                    <img src={Logo} style={{height:65, marginTop:20}}/>
                    </Link> 
                 
                         <p>Create Your Account</p>
                        <div className="auth-form-container text-start">
                            <form className="auth-form" method="POST" onSubmit={register} autoComplete={'off'}>

                                <div className="name mb-3">
                                    <TextField className={`form-control ${validate.validate && validate.validate.name ? 'is-invalid ' : ''}`}

                                      type="text"
                                      id="name"
                                      name="name"
                                      value={name}
                                      onChange={(e) => setName(e.target.value)}
                                        label="First name"
                                        variant="outlined"
                                        size="small"
                                    />
                                       <div className={`invalid-feedback text-start ${(validate.validate && validate.validate.name) ? 'd-block' : 'd-none'}`} >
                                        {(validate.validate && validate.validate.name) ? validate.validate.name[0] : ''}
                                    </div>
                                </div>

                                <div className="name mb-3">
                                    <TextField
                                        className={`form-control`}
                                      type="text"
                                      id="name"
                                      name="name"
                                    //   value={name}
                                    //   onChange={(e) => setName(e.target.value)}
                                        label="Last name"
                                        variant="outlined"
                                        size="small"
                                    />
                                </div>

                              
                                <div className="email mb-3">
                                <TextField
                                     type="email"
                                     className={`form-control ${validate.validate && validate.validate.email ? 'is-invalid ' : ''}`}
                                     id="email"
                                     name="email"
                                     value={email}
                                     onChange={(e) => setEmail(e.target.value)}
                                        label="Email"
                                        variant="outlined"
                                        size="small"
                                    />
                                    <div className={`invalid-feedback text-start ${(validate.validate && validate.validate.email) ? 'd-block' : 'd-none'}`} >
                                        {(validate.validate && validate.validate.email) ? validate.validate.email[0] : ''}
                                    </div>
                                </div>


                               
             
                                
                                <div className="password mb-3">
                                    <div className="input-group">             
                                <TextField
                                    type={showPassword ? 'text' : 'password'}
                                    className={`form-control ${validate.validate && validate.validate.password ? 'is-invalid ' : ''}`}
                                    name="password"
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                        label="Password"
                                        variant="outlined"
                                        size="small"
                                    />
                                        {/* <Button type="button" size="small" variant="contained"  onClick={(e) => togglePassword(e)} ><i className={showPassword ? 'far fa-eye' : 'far fa-eye-slash'} ></i> </Button> */}

                                        <button type="button"  className="btn btn-outline-primary btn-sm" onClick={(e) => togglePassword(e)} ><i className={showPassword ? 'far fa-eye' : 'far fa-eye-slash'} ></i> </button>

                                        <div className={`invalid-feedback text-start ${(validate.validate && validate.validate.password) ? 'd-block' : 'd-none'}`} >
                                            {(validate.validate && validate.validate.password) ? validate.validate.password[0] : ''}
                                        </div>
                                    </div>
                                    </div>


                                
                                    <div className="password mb-3">
                                    <div className="input-group">             
                                <TextField
                                    type={c_showPassword ? 'text' : 'password'}
                                    className={`form-control`}
                                    name="password"
                                    id="password"
                                    value={c_password}
                                    onChange={(e) => setc_Password(e.target.value)}
                                        label="Confirm password"
                                        variant="outlined"
                                        size="small"
                                    />
                                        <button type="button"  className="btn btn-outline-primary btn-sm" onClick={(e) => togglePassword2(e)} ><i className={c_showPassword ? 'far fa-eye' : 'far fa-eye-slash'} ></i> </button>
                                    </div>
                                    </div>




                                <div className="text-center">
                                <Button variant="contained" style={{ textTransform: 'none'}} type="submit" className="btn btn-primary w-100 theme-btn mx-auto">Sign Up</Button>
                                    {/* <button type="submit" className="btn btn-primary w-100 theme-btn mx-auto">Sign Up</button> */}
                                </div>
                            </form>

                            <hr />
                            <div className="auth-option text-center pt-2">Already have an account? <Link className="text-link" to="/login" >Sign in</Link></div>
                        
                            <br />
                            <div className="auth-option text-center pt-2">
                                <a className="text-link  p-1" target="_blank" href="https://www.facebook.com" >
                               <img height="25" src={"https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_facebook-512.png"} />
                                </a>
                                
                                <a className="text-link p-2" target="_blank" href="https://www.twitter.com" >
                               <img height="25" src={"https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_twitter-256.png"} />
                                </a>

                                <a className="text-link p-1" target="_blank" href="https://www.instagram.com" >
                               <img height="25" src={"https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_instagram-512.png"} />
                            </a>
                          
                            </div>
                            <div className="auth-option text-center pt-2 text-link">Fllow Us</div>
                            <br />
                            <br />

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Register;